import { P0, S, abs, earShape, fillAt, max, sq } from '../../geometry';

export const axolotl = {
  name: 'Axolotl',
  colors: ['#D6409F', '#8E4EC6'],
  draw(m, t) {
    let A = 9,
      sp = 2,
      spread = 0,
      droop = 0,
      hw = 26,
      pose = P0();
    if (m === 'happy') {
      A = 16;
      sp = 11;
      spread = 6;
      pose.ty = -2.5 * abs(S(t * 6));
    }
    // Thinking: a slow wave keeps rolling down the frilly gills.
    if (m === 'thinking') {
      A = 30;
      sp = 4;
      pose.rot = 3 * S(t * 1.2);
    }
    if (m === 'talking') {
      sp = 6;
      hw = 26 + 3 * max(0, S(t * 10));
    }
    if (m === 'surprised') {
      A = 4;
      sp = 26;
      spread = 16;
    }
    if (m === 'paused') {
      A = 3;
      sp = 0.8;
      spread = -8;
      droop = 30;
      pose.ty = 2;
      pose.sy = 0.95;
    }
    const bases = [
      [33, 46],
      [28, 55],
      [30, 64],
    ];
    const gills = [-1, 1].flatMap((side) =>
      bases.map(([bx, by], i) => {
        const ang = side * (70 + (i - 1) * (35 + spread) + droop),
          bend = side * A * S(t * sp - i * 1.1);
        return {
          c: 'b',
          pts: earShape(side < 0 ? bx : 100 - bx, by, ang, bend, 14, 3.4)
            .outline,
          n: 18,
        };
      })
    );
    return {
      strokes: [...gills, { c: 'a', pts: sq(50, 58, hw, 19, 2.6), n: 30 }],
      eyes: { x: 50, y: 57 },
      pose,
    };
  },
  eyesOn: 'a',
  solid: (f) => fillAt(f, 0, 1, 2, 3, 4, 5, 6),
};
